'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

exports.routing = routing;

var _actionTypes = require('../constants/actionTypes');

var INITIAL_STATE = {};

function routing() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
  var action = arguments[1];

  if (_actionTypes.ROUTING_ACTIONS_KEYS.indexOf(action.type) !== -1) {
    var type = action.type;
    var meta = action.meta;
    var _action$params = action.params;
    var params = _action$params === undefined ? {} : _action$params;

    var foreignUser = params.userId;
    return _extends({}, state, { foreignUser: foreignUser, type: type, params: params, meta: meta });
  }
  return state;
}


//////////////////
// WEBPACK FOOTER
// ./app/reducers/routing.js
// module id = 630
// module chunks = 1